"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const orderBy_1 = __importDefault(require("lodash/orderBy"));
const ClassService_1 = __importDefault(require("modules/classManager/ClassService"));
const ClassServiceUtil_1 = __importDefault(require("modules/classManager/ClassServiceUtil"));
const formartMarketplaceClassOffers = (marketplaceClassOffers, isCurrentDefaultClass) => {
    const items = marketplaceClassOffers.map((marketplaceClassOffer) => {
        return {
            ...marketplaceClassOffer,
            isSelectedByDefaultClass: Boolean(isCurrentDefaultClass && marketplaceClassOffer.defaultClass)
        };
    });
    return (0, orderBy_1.default)(items, ['isSelectedByDefaultClass'], ['desc']);
};
const useOffer = ({ classId }) => {
    const [offers, setOffers] = (0, react_1.useState)([]);
    const [initialSelectedOffers, setInitialSelectedOffers] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const fetchOffers = async () => {
            const marketplaceClassOffers = await ClassService_1.default.getFormatedOffersWithClasses();
            let isCurrentDefaultClass = false;
            if (classId) {
                const currentClass = await ClassService_1.default.getClassById(classId);
                if (currentClass) {
                    const selectedOfferKeys = await ClassServiceUtil_1.default.filterOffersCurrentlyOnTheMarketplace(currentClass.offers, marketplaceClassOffers);
                    isCurrentDefaultClass = currentClass.defaultClass;
                    setInitialSelectedOffers(selectedOfferKeys);
                }
            }
            const customMarketplaceClassOffers = formartMarketplaceClassOffers(marketplaceClassOffers, isCurrentDefaultClass);
            setOffers(customMarketplaceClassOffers);
        };
        fetchOffers();
    }, [classId]);
    return {
        offers,
        initialSelectedOffers
    };
};
exports.default = useOffer;
